/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CopyIcon16Light = forwardRef('CopyIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 1A2.5 2.5 0 0 0 2 3.5v8A2.5 2.5 0 0 0 4.5 14h5a2.5 2.5 0 0 0 2.5-2.5v-8A2.5 2.5 0 0 0 9.5 1h-5ZM3 3.5A1.5 1.5 0 0 1 4.5 2h5A1.5 1.5 0 0 1 11 3.5v8A1.5 1.5 0 0 1 9.5 13h-5A1.5 1.5 0 0 1 3 11.5v-8Z" }),
        React.createElement("path", { d: "M14 6.5a.5.5 0 0 0-1 0V12a3 3 0 0 1-3 3H5.5a.5.5 0 0 0 0 1H10a4 4 0 0 0 4-4V6.5Z" })));
});
